module.exports = __webpack_public_path__ + "static/media/statistics.6bc91525.png";